import { connect } from 'react-redux'
import { selectors } from '@opallabs/wormhole'
import MomentWorkflowStatus from './index'

const statusTypes = {
  approved: 'approved',
  tasksComplete: 'tasksComplete',
  approvalPending: 'approvalPending',
  tasksPending: 'tasksPending',
  declined: 'declined',
  circuitBreaker: 'circuitBreaker',
  notStarted: 'notStarted',
  notCreated: 'notCreated',
}

const computeStatus = (workflow) => {
  if (!workflow) {
    return statusTypes.notCreated
  }

  const latestStage = workflow.latest_active_stage

  if (workflow.status === 'complete') {
    return workflow.is_approved
      ? statusTypes.approved
      : statusTypes.tasksComplete
  }

  if (workflow.status === 'active') {
    if (latestStage?.stage_type === 'approval') {
      return latestStage.assignment_counts?.declined
        ? statusTypes.declined
        : statusTypes.approvalPending
    }
    return statusTypes.tasksPending
  }
  if (workflow.status === 'paused' && workflow.completed_stages > 1) {
    return statusTypes.circuitBreaker
  }

  return statusTypes.notStarted
}

const mapStateToProps = (state, ownProps) => {
  const context = selectors.selectContextByEntityId(
    state,
    'moment',
    ownProps.moment.id
  )
  if (context) {
    const workflow = selectors.selectWorkflowByContext(state, context.id)
    return { workflowStatus: computeStatus(workflow) }
  }
  return { workflowStatus: computeStatus() }
}

const ConnectedMomentWorkflowStatus =
  connect(mapStateToProps)(MomentWorkflowStatus)

export default ConnectedMomentWorkflowStatus
